var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-logo"},[[_c('span',{key:"1",staticClass:"vue-logo_title"},[(!_vm.isCollapse)?_c('div',[_vm._v(_vm._s(_vm.title))]):_c('div',[_vm._v("G")])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }